<template>
  <div class="pt40 between" v-loading.fullscreen.lock="loading">
    <!-- 顶部状态、交易代码、设立资料 -->
    <top-status-information />

    <!-- 确认套餐 -->
    <confirm-package />

    <!-- 申请步骤回显 -->
    <application-steps-echo ref="applicationStepsEchoRef" />

    <!-- 电子发票信息 -->
    <electronic-invoiceInfo ref="electronicInvoiceInfoRef" disabled></electronic-invoiceInfo>

    <!-- 相关申请选择(二选一)、协议签署 -->
    <declare-and-protocol ref="declareAndProtocolRef" disabled :voucher="voucher"></declare-and-protocol>
  </div>
</template>

<script>
import TopStatusInformation from "./components/TopStatusInformation";
import ConfirmPackage from "../components/ConfirmPackage";
import ApplicationStepsEcho from "../components/ApplicationStepsEcho";
import ElectronicInvoiceInfo from "../components/ElectronicInvoiceInfo";
import DeclareAndProtocol from "../components/DeclareAndProtocol";
import { mapState, mapActions } from "vuex";
export default {
  name: "EnrollDetails",
  components: {
    TopStatusInformation,
    ConfirmPackage,
    ApplicationStepsEcho,
    ElectronicInvoiceInfo,
    DeclareAndProtocol,
  },
  data() {
    return {
      applyId: null,
      loading: false,
    };
  },
  computed: {
    ...mapState("applyment", ["applymentDetail"]),
    // CRM后台用户令牌(存在时供子组件跳转携带)
    voucher() {
      const raw = this.$route.query.voucher;
      return raw ? decodeURI(raw) : "";
    },
  },
  methods: {
    ...mapActions("applyment", ["fetchApplymentDetail", "fetchAdminApplymentDetail"]),
    // 获取申请单详情 - 前台
    async getFrontDetails() {
      this.loading = true;
      try {
        await this.fetchApplymentDetail(this.applyId);
        this.pageInit();
      } catch (error) {
        this.loading = false;
      }
    },
    // 获取申请单详情 - 后台
    async getAdminDetails(voucher) {
      this.loading = true;
      try {
        await this.fetchAdminApplymentDetail({ id: this.applyId, key: voucher });
        this.pageInit();
      } catch (error) {
        this.loading = false;
      }
    },
    // 页面初始化数据整理
    pageInit() {
      // 初始化申请步骤回显
      this.$refs.applicationStepsEchoRef.init();
      // 初始化电子发票信息
      this.$refs.electronicInvoiceInfoRef.init();
      // 初始化声明和协议
      this.$refs.declareAndProtocolRef.init();
      // 加载完毕
      this.$nextTick(() => {
        this.loading = false;
      });
    },
  },
  created() {
    // 检查url是否存在参数(id)
    const query = this.$route.query;
    if (query.id) {
      this.applyId = query.id;
      if (query.voucher) {
        let voucher = decodeURI(query.voucher);
        // 获取申请单详情 - 后台
        this.getAdminDetails(voucher);
      } else {
        // 获取申请单详情 - 前台
        this.getFrontDetails();
      }
    } else {
      // 给出提示：缺少参数
      this.$message({
        message: this.$t("common.error.scarce"),
        type: "error",
        duration: 1000,
        onClose: () => {
          this.$router.replace("/");
        },
      });
    }
  },
};
</script>

<style lang="scss" scoped></style>
